import { render, staticRenderFns } from "./DownloadList.vue?vue&type=template&id=f4b31d5e&scoped=true"
import script from "./DownloadList.vue?vue&type=script&lang=js"
export * from "./DownloadList.vue?vue&type=script&lang=js"
import style0 from "./DownloadList.vue?vue&type=style&index=0&id=f4b31d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b31d5e",
  null
  
)

export default component.exports